<template>
    <section class="quick-link quick-link-style1 parallax mg-bottom30">
        <div class="container" style="">
            <div class="row course-package-card" v-bind:style="{backgroundImage: component.background ? 'url(https://fabricfour.blob.core.windows.net/mhslearning-upload/' + component.background.imageFileName + ')' : '', backgroundColor: alphaColor}">
                <div class="col-lg-7" style="padding-left: 30px;">
                    <div class="wrap-link-left">
                        <div class="caption lt-sp275 accent-secondary-tx">
                            {{component.text ? component.text : 'Purchase as part of a package and save'}}
                        </div>
                        <div class="heading-lf lt-sp03">
                            {{ coursePackage.name }}
                        </div>
                        <p>
                            {{ coursePackage.descriptionShort }}
                        </p>
                        <div class="price" style="margin-top: 20px">
                            <span class="price-now accent-secondary-tx">R {{ coursePackage.price + " Excl VAT" }}</span>
                            <span class="price-old"><del>R {{ totalValue + " Excl VAT" }}</del></span>
                        </div>
                        <div v-if="totalValueUsd" class="price" style="margin-top: 20px">
                            <span class="price-now">$ {{ coursePackage.priceUsd}}<span v-if="coursePackage.priceUsd" class="text-smaller"> Excl. VAT</span></span>
                            <span class="price-old"><del>$ {{ totalValueUsd}}</del><span v-if="coursePackage.totalValueUsd" class="text-smaller"> Excl. VAT</span></span>
                        </div>
                        <div class="btn-apply-link">
                            <ul>
                                <li>
                                    <button v-on:click="addToCart" class="btn btn-site-primary">Add to cart</button>
                                </li>
                                <!--
                    <li>
                        <a class="btn btn-request lt-sp06">More details</a>
                    </li>
                        -->
                            </ul>
                        </div>
                        <p class="text-danger">{{ packageError }}</p>
                    </div>
                </div>
                <div class="col-lg-5" style="padding-right: 30px;">
                    <div class="wrap-link-right">
                        <div class="heading-rg">
                            <span>Included Courses</span>
                        </div>
                        <ul class="info-quick-link">
                            <li v-for="course in coursePackage.courses">
                                <img :src="course | s3url" style="width: 29px; height: 31px" alt="images">
                                <router-link :to="{ name: 'CourseInfo', params: { id: course.id }}">{{ course.name }}</router-link>
                                <span class="text-success" v-if="ownedCourseIds.indexOf(course.id) > -1"> (Already owned)</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
    .text-smaller {
        font-size: 12px;
        white-space: nowrap;
    }

    .quick-link {
        position: inherit;
    }

    .heading-lf {
        color: white;
    }

    .caption {
        color: #ff9933;
    }

    .btn-apply-link {
        margin-top: 20px;
    }

    .bg-clff5f60 {
        background-color: white;
        color: #3d3c79 !important;
    }

    .course-package-card {
        background-image: url('/wwwroot/images/lightning-4.jpg');
        background-blend-mode: multiply;
        background-position: center;
        background-size: cover;
        padding-top: 30px !important;
        padding-bottom: 30px !important;
        margin-left: -18px;
        margin-right: -18px;
    }

    .price-now {
        font-size: 28px;
        color: #ff9933;
        margin-right: 10px;
        font-weight: bold;
    }

    .price-old {
        font-size: 24px;
        color: white;
    }
</style>
<script>
    export default {
        name: 'CoursePackageComponent',
        props: {
            coursePackage: Object,
            component: Object
        },
        data() {
            return {
                packageError: '',
                ownedCourseIds: []
            }
        },
        methods: {
            addToCart() {
                this.packageError = '';

                var alreadyOwned = this.coursePackage.courses.filter(x => this.ownedCourseIds.indexOf(x.id) > -1);

                if (alreadyOwned.length > 0) {
                    this.packageError = "You already own the following course(s) in this package: " + alreadyOwned.map(x => x.name).join(", ") + ". This package cannot be added to your cart.";
                    return;
                }

                this.$store.commit("addToCart", {
                    type: "package",
                    id: this.coursePackage.id,
                    name: this.coursePackage.name,
                    price: this.coursePackage.price,
                    priceUsd: this.coursePackage.priceUsd,
                    imageFileName: this.coursePackage.imageFileName
                });
            },
        },
        computed: {
            totalValue() {
                var total = this.coursePackage.courses.reduce((total, course) => total + course.price, 0);
                return total;
            },
            totalValueUsd() {
                var total = this.coursePackage.courses.reduce((total, course) => total + course.priceUsd, 0);

                if (total == undefined || isNaN(total) || total == null)
                    return null;

                return total;
            },
            alphaColor() {
                var comp = this.component;
                if (comp.background && comp.background.overlay && comp.background.opacity) {
                    var _opacity = Math.round(Math.min(Math.max(comp.background.opacity || 1, 0), 1) * 255);
                    var result = comp.background.overlay + _opacity.toString(16).toUpperCase();
                    return result;
                }
            }
        },
        async mounted() {
            //console.log(this.alphaColor);

            if (this.$store.state.isAuthenticated) {
                var ownedCourses = await this.web("/courses?filters=user");
                this.ownedCourseIds = ownedCourses.map(x => x.id);
            }
        }
    }
</script>

<style scoped>
</style>